import { Component } from "@angular/core";
import { FieldArrayType } from "@ngx-formly/core";

@Component({
    selector: "formly-repeat-section",
    template: `
        <div *ngFor="let field of field.fieldGroup; let i = index" class="w-full flex flex-row items-center">
            <formly-field class="w-full" [field]="field"></formly-field>
            <div class="flex-none ml-4 mr-4 mt-2" *ngIf="!to.useIcon">
                <button mat-button (click)="remove(i)">Remover</button>
            </div>
            <div class="ml-4 mt-2" *ngIf="to.useIcon">
                <button mat-icon-button (click)="remove(i)">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </div>
        <button mat-button (click)="add()">{{ to.addText }}</button>
    `,
})
export class RepeatTypeComponent extends FieldArrayType {}
